<template>
    <div class="menu-bar">
        <div class="menu-bar--wrapped">
            <div class="menu-bar--start">
                <ul v-if="userType !== ''" class="menu-bar__list">
                    <li class="menu-bar__list__item">
                        <RouterLink
                            :to="{ name: 'dashboard' }"
                            class="menu-bar__list__item__link"
                            active-class="menu-bar__list__item__link--current"
                        >
                            <IconDashboard hexColor="#fff" />
                            {{ $t('components.menuBar.overview') }}
                        </RouterLink>
                    </li>

                    <!-- Landlord -->
                    <li v-if="userType === 'landlord'" class="menu-bar__list__item">
                        <RouterLink
                            :to="{ name: 'profile' }"
                            class="menu-bar__list__item__link"
                            active-class="menu-bar__list__item__link--current"
                        >
                            {{ $t('components.menuBar.landlord.profile') }}
                        </RouterLink>
                    </li>
                    <li v-if="userType === 'landlord'" class="menu-bar__list__item">
                        <RouterLink
                            :to="{ name: 'templates' }"
                            class="menu-bar__list__item__link"
                            active-class="menu-bar__list__item__link--current"
                        >
                            {{ $t('components.menuBar.landlord.templates') }}
                        </RouterLink>
                    </li>

                    <!-- Company -->
                    <li v-if="userType === 'company'" class="menu-bar__list__item">
                        <RouterLink
                            :to="{ name: 'add-tenant' }"
                            class="menu-bar__list__item__link"
                            active-class="menu-bar__list__item__link--current"
                        >
                            <IconHouseSingle hexColor="#fff" />
                            {{ $t('components.menuBar.company.register') }}
                        </RouterLink>
                    </li>
                    <li v-if="userType === 'company'" class="menu-bar__list__item">
                        <RouterLink
                            :to="{ name: 'edit-company' }"
                            class="menu-bar__list__item__link"
                            active-class="menu-bar__list__item__link--current"
                        >
                            <IconSettings hexColor="#fff" />
                            {{ $t('components.menuBar.company.change') }}
                        </RouterLink>
                    </li>
                </ul>
            </div>

            <div class="menu-bar--end">
                <ul class="menu-bar__list">
                    <li class="menu-bar__list__item">
                        <span class="menu-bar__list__item__link" @click="logout">
                            {{ $t('components.menuBar.logout') }}
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent }  from 'vue'
    import { useStore }         from 'vuex'
    import { useRouter }        from 'vue-router'
    import authStoreActions     from '@constans/store/auth/authStoreActions'
    import userStoreGetters     from '@constans/store/user/userStoreGetters'
    import IconDashboard        from '@components/icons/IconDashboard.vue'
    import IconHouseSingle      from '@components/icons/IconHouseSingle.vue'
    import IconSettings         from '@components/icons/IconSettings.vue'

    export default defineComponent({
        components: {
            IconDashboard,
            IconHouseSingle,
            IconSettings
        },
        setup() {
            const store = useStore()
            const router = useRouter()

            const userType = computed(() => store.getters[`user/${ userStoreGetters.GET_USER_ROLE }`])

            const logout = () => store.dispatch(`auth/${ authStoreActions.LOGOUT }`).then(() => router.push({ name: 'login' }))

            return {
                userType,
                logout
            }
        }
    })
</script>
